/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminNorthPlanId { 
    account_id?: string;
    card_not_present_equipment_id?: string;
    card_present_equipment_id?: string;
    id?: string;
    plan_id: string;
    pricing_type: AdminNorthPlanId.PricingTypeEnum;
}
export namespace AdminNorthPlanId {
    export type PricingTypeEnum = 'flat_rate' | 'interchange';
    export const PricingTypeEnum = {
        FLAT_RATE: 'flat_rate' as PricingTypeEnum,
        INTERCHANGE: 'interchange' as PricingTypeEnum
    };
}


